import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpBackend } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError, map } from 'rxjs/operators';
import { UrlProviderserviceService } from '../../applicationinfraestructure/services/url-providerservice.service';
import { HttpErrorHandler } from '../../applicationinfraestructure/helpers/HttpErrorHanlder';
import { IEdificios } from '../interfaces/Edificios';
import { IRegistroVentasItem } from '../interfaces/IRegistroVentaItems';
import { IFiltrosConsulta, IFiltrosConsultaCharts } from '../interfaces/FiltrosConsulta';
import { IConsultaRegistroVentas } from '../interfaces/ConsultaRegistroVentas';
import { IContratos } from '../interfaces/Contratos';
import { ResultObject, UsersData } from '../../applicationinfraestructure/interfaces/userData';
import { environment } from '../../../environments/environment';
import { IUsuarios } from '../interfaces/Usuarios';
import { IMarcas } from '../interfaces/Marcas';
import { IFiltrosReporte } from '../interfaces/FiltrosReporte';
import { IMonitorVentas } from '../interfaces/MonitorVentas';
import { IFiltrosMonitor } from '../interfaces/FiltrosMonitor';
import { IRegistroVentasCertificadas } from '../interfaces/RegistroVentasCertificadas';
import { IConsultaVentasCertificadas } from '../interfaces/ConsultaVentasCertificadas';
import { IFiltrosMonitorVentasCertificadas } from '../interfaces/FiltrosMonitorVentasCertificadas';
import { IMonitorVentasCertificadas } from '../interfaces/MonitorVentasCertificadas';
import { IFiltrosReporteVentaCertificada } from '../interfaces/FiltrosReporteVentaCertificada';
import { IFiltrosListadoClientes } from '../interfaces/FiltrosListadoClientes';
import { IFacturacion } from '../interfaces/Facturacion';
import { IParameters } from '../interfaces/Parametros';
import { filterPage, PagedResult } from '../interfaces/PagedResult';

@Injectable({
  providedIn: 'root'
})
export class RegistroVentasService extends HttpErrorHandler {

  private headers = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',

    })
  };
  private readonly httpDirectBackend: HttpClient;

  constructor(
    private http: HttpClient,
    private readonly httpBackend: HttpBackend,
    private urlProvider: UrlProviderserviceService) {
    super();
    this.httpDirectBackend = new HttpClient(httpBackend);
  }

  getSoporte(urlSoporte: string) {
    if (environment.tipoUsuario == 'Marca' || environment.tipoUsuario == 'MarcaCertificada') {
      return this.httpDirectBackend.get<IContratos[]>(this.urlProvider.getApiUrlExterno('getSoporte') + '?urlSoporte=' + urlSoporte);
    }
    else {
      return this.httpDirectBackend.get<IContratos[]>(this.urlProvider.getApiUrl('getSoporte') + '?urlSoporte=' + urlSoporte);
    }
  }


  getContratos(edificios: string, marcas: string, mes: string = '', anio: string = ''): Observable<IContratos[]> {
    if (environment.tipoUsuario == 'Marca' || environment.tipoUsuario == 'MarcaCertificada') {
      return this.httpDirectBackend.get<IContratos[]>(this.urlProvider.getApiUrlExterno('getContratosMarca') + '?Edificios=' + edificios + '&Marcas=' + marcas + '&mes=' + mes + '&anio=' + anio);
    }
    else {
      return this.httpDirectBackend.get<IContratos[]>(this.urlProvider.getApiUrl('getContratos') + '?Edificios=' + edificios + '&Marcas=' + marcas + '&mes=' + mes + '&anio=' + anio);
    }
  }

  saveRegistroVentas(registroVentas: IRegistroVentasItem) {
    const _httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8'
      })
    };



    if (environment.tipoUsuario == 'Marca') {
      return this.httpDirectBackend.post<boolean>(this.urlProvider.getApiUrlExterno('saveRegistroVentasMarca'), JSON.stringify(registroVentas), _httpOptions)
        .pipe(
          retry(1),
          catchError(
            this.errorHandler
          )
        );
    }
    else {
      return this.httpDirectBackend.post<boolean>(this.urlProvider.getApiUrl('saveRegistroVentas'), JSON.stringify(registroVentas), _httpOptions)
        .pipe(
          retry(1),
          catchError(
            this.errorHandler
          )
        );
    }
  }

  guardarRegistroVentaCertificada(registroVentas: IRegistroVentasCertificadas) {
    const _httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8'
      })
    };

    if (environment.tipoUsuario == 'MarcaCertificada') {
      return this.httpDirectBackend.post<boolean>(this.urlProvider.getApiUrlExterno('guardarRegistroVentasCertificadasMarca'), JSON.stringify(registroVentas), _httpOptions)
        .pipe(
          retry(1),
          catchError(
            this.errorHandler
          )
        );
    }
    else {
      return this.httpDirectBackend.post<boolean>(this.urlProvider.getApiUrl('guardarRegistroVentasCertificadas'), JSON.stringify(registroVentas), _httpOptions)
        .pipe(
          retry(1),
          catchError(
            this.errorHandler
          )
        );
    }


  }



  actualizarRegistroVentasCertificada(actualizar: any) {
    if (environment.tipoUsuario == 'MarcaCertificada') {
      return this.httpDirectBackend.post(this.urlProvider.getApiUrlExterno('actualizarConsultaMarcaCertificada'), actualizar, this.headers)
    }
    else {
      return this.httpDirectBackend.post(this.urlProvider.getApiUrl('actualizarConsultaCertificada'), actualizar, this.headers)
    }

  }

  guardarRegistroVentas(actualizar: any) {
    if (environment.tipoUsuario == 'Marca') {
      return this.httpDirectBackend.post(this.urlProvider.getApiUrlExterno('guardarRegistroVentasMarca'), actualizar, this.headers)
    }
    else {
      return this.httpDirectBackend.post(this.urlProvider.getApiUrl('guardarRegistroVentas'), actualizar, this.headers)
    }

  }


  actualizarRegistroVentas(actualizar: any) {

    if (environment.tipoUsuario == 'Marca') {
      return this.httpDirectBackend.post(this.urlProvider.getApiUrlExterno('actualizarConsultaMarca'), JSON.stringify(actualizar), this.headers)
    }
    else {
      return this.httpDirectBackend.post(this.urlProvider.getApiUrl('actualizarConsulta'), JSON.stringify(actualizar), this.headers)
    }

  }

  getEdificiosRegistro(edificios: string, marcas: string): Observable<IEdificios[]> {
    if (environment.tipoUsuario == 'Marca' || environment.tipoUsuario == 'MarcaCertificada') {
      return this.httpDirectBackend.get<IEdificios[]>(this.urlProvider.getApiUrlExterno('getEdificiosRegistroMarca') + '?edificios=' + edificios + '&marcas=' + marcas + '');
    }
    else {
      return this.httpDirectBackend.get<IEdificios[]>(this.urlProvider.getApiUrl('getEdificiosRegistro') + '?edificios=' + edificios + '&marcas=' + marcas + '');
    }

  }

  getEdificiosConsulta(edificios: string, marcas: string): Observable<IEdificios[]> {
    if (environment.tipoUsuario == 'Marca' || environment.tipoUsuario == 'MarcaCertificada') {
      return this.httpDirectBackend.get<IEdificios[]>(this.urlProvider.getApiUrlExterno('getEdificiosConsultaMarca') + '?edificios=' + edificios + '&marcas=' + marcas + '');
    }
    else {
      return this.httpDirectBackend.get<IEdificios[]>(this.urlProvider.getApiUrl('getEdificiosConsulta') + '?edificios=' + edificios + '&marcas=' + marcas + '');
    }

  }
  getResultCharts(filtros: IFiltrosConsultaCharts): Observable<any[]> {

    const _httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8'
      })
    };
    return this.httpDirectBackend.post<any>(this.urlProvider.getApiUrl('reporteMarcas'), filtros, _httpOptions)
      .pipe(
        retry(1),
        catchError(
          this.errorHandler
        )
      );
  }
  getConsulta(filtros: IFiltrosConsulta): Observable<PagedResult<IConsultaRegistroVentas>> {
    if (environment.tipoUsuario == 'Marca') {
      return this.httpDirectBackend.post(this.urlProvider.getApiUrlExterno('getConsultaMarca'), filtros, this.headers)
        .pipe(map(data => data as PagedResult<IConsultaRegistroVentas>));
    }
    else {
      return this.httpDirectBackend.post(this.urlProvider.getApiUrl('getConsulta'), filtros, this.headers)
        .pipe(map(data => data as PagedResult<IConsultaRegistroVentas>));
    }
  }

  getConsultaVentaCertificada(filtros: IFiltrosConsulta): Observable<IConsultaVentasCertificadas[]> {

    if (environment.tipoUsuario == 'MarcaCertificada') {
      return this.httpDirectBackend.post(this.urlProvider.getApiUrlExterno('getConsultaMarcaCertificada'), filtros, this.headers)
        .pipe(map(data => data as IConsultaVentasCertificadas[]));
    }
    else {
      return this.httpDirectBackend.post(this.urlProvider.getApiUrl('getConsultaCertificada'), filtros, this.headers)
        .pipe(map(data => data as IConsultaVentasCertificadas[]));
    }
  }

  getConsultaReporte(filtros: IFiltrosReporte): Observable<any[]> {

    return this.httpDirectBackend.post(this.urlProvider.getApiUrl('getConsultaReporte'), filtros, this.headers)
      .pipe(map(data => data as any[]));

  }

  getConsultaReporteVentasCertificadas(filtros: IFiltrosReporteVentaCertificada): Observable<any[]> {

    return this.httpDirectBackend.post(this.urlProvider.getApiUrl('getConsultaReporteVentasCertificadas'), filtros, this.headers)
      .pipe(map(data => data as any[]));

  }


  validarUsuarioMarca(email: string, clave: string): Observable<UsersData> {
    return this.httpDirectBackend.get<UsersData>(this.urlProvider.getApiUrlExterno('validarUsuarioMarca') + '?email=' + email + '&clave=' + clave + '');

  }

  generarTokenCambioContrasena(_email: string): Observable<any> {
    const _httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8'
      })
    };

    return this.httpDirectBackend.post<any>(this.urlProvider.getApiUrl('generarToken'), JSON.stringify({ email: _email }), _httpOptions)
      .pipe(
        retry(1),
        catchError(
          this.errorHandler
        )
      );
  }
  cambioContrasena(_password: string, _token: any): Observable<any> {
    const _httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8'
      })
    };
    return this.httpDirectBackend.post<any>(this.urlProvider.getApiUrl('cambiarContrasena'), JSON.stringify({ pass: _password, token: _token }), _httpOptions)
      .pipe(
        retry(1),
        catchError(
          this.errorHandler
        )
      );
  }

  obtenerUsuarios(filter: filterPage): Observable<PagedResult<IUsuarios>> {
    return this.httpDirectBackend.get<PagedResult<IUsuarios>>(
      this.urlProvider.getApiUrl('obtenerusuario') + `?pageIndex=${filter.pageIndex}&pageSize=${filter.pageSize}&search=${filter.search}`);
  }

  obtenerMarcas(): Observable<IMarcas[]> {
    return this.httpDirectBackend.get<IMarcas[]>(this.urlProvider.getApiUrl('obtenermarcas'));
  }
  obtenerMarcasIds(marcas: string[]): Observable<IMarcas[]> {
    const _httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8'
      })
    };
    return this.httpDirectBackend.post<IMarcas[]>(this.urlProvider.getApiUrl('obtenermarcasids'), marcas, _httpOptions)
      .pipe(
        retry(1),
        catchError(
          this.errorHandler
        )
      );
  }

  obtenerEdificios(): Observable<IEdificios[]> {
    return this.httpDirectBackend.get<IEdificios[]>(this.urlProvider.getApiUrl('obteneredificios'));
  }

  deleteUser(identificacion: string): Observable<any> {
    return this.httpDirectBackend.get<any>(this.urlProvider.getApiUrl('deleteUser') + '?identificacion=' + identificacion + '');

  }

  crearUsuario(usuario: IUsuarios) {
    const _httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8'
      })
    };

    return this.httpDirectBackend.post<boolean>(this.urlProvider.getApiUrl('crearUsuario'), JSON.stringify(usuario), _httpOptions)
      .pipe(
        retry(1),
        catchError(
          this.errorHandler
        )
      );
  }

  actualizarUsuario(usuario: IUsuarios) {
    const _httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8'
      })
    };

    return this.httpDirectBackend.post<boolean>(this.urlProvider.getApiUrl('actualizarUsuario'), JSON.stringify(usuario), _httpOptions)
      .pipe(
        retry(1),
        catchError(
          this.errorHandler
        )
      );

  }

  usuarioId(identificacion: string): Observable<IUsuarios> {
    return this.httpDirectBackend.get<IUsuarios>(this.urlProvider.getApiUrl('usuarioId') + '?identificacion=' + identificacion + '');

  }

  getMonitorVentas(filtros: IFiltrosMonitor): Observable<IMonitorVentas[]> {

    return this.httpDirectBackend.post(this.urlProvider.getApiUrl('getMonitorVentas'), filtros, this.headers)
      .pipe(map(data => data as IMonitorVentas[]));

  }

  getMonitorVentasCertificadas(filtros: IFiltrosMonitorVentasCertificadas): Observable<IMonitorVentasCertificadas[]> {

    return this.httpDirectBackend.post(this.urlProvider.getApiUrl('getMonitorVentasCertificadas'), filtros, this.headers)
      .pipe(map(data => data as IMonitorVentasCertificadas[]));

  }

  obtenerListadoClientes(filtros: IFiltrosListadoClientes): Observable<IMonitorVentasCertificadas[]> {

    return this.httpDirectBackend.post(this.urlProvider.getApiUrl('obtenerListadoClientes'), filtros, this.headers)
      .pipe(map(data => data as IMonitorVentasCertificadas[]));

  }

  consultarFactura(registro: IRegistroVentasCertificadas, mes: string, year: string): Promise<any> {
    try {
      if (mes == '1') {
        year = (Number(year) - 1).toString();
        mes = '12';
      }
      else {
        mes = (Number(mes) - 1).toString();
      }
    }
    catch (e) {
      return Promise.reject('Se especificó un mes o año con formato inválido');
    }

    const periodo = `${year}0${mes.length > 1 ? mes : `0${mes}`}`;

    const payload: IFacturacion = {
      codEdificio: registro.codEdificio,
      codMarca: registro.codMarca,
      contrato: registro.contrato,
      periodo: periodo,
      porcentaje: registro.porcentaje,
      sociedad: registro.sociedad,
      periodovc: year + mes
    };


    if (environment.tipoUsuario == 'MarcaCertificada') {
      return this.http.post(this.urlProvider.getApiUrlExterno('consultarFacturaMarca'), payload).toPromise();
    }
    else {
      return this.http.post(this.urlProvider.getApiUrl('consultarFactura'), payload).toPromise();
    }


  }

  getParametros(name: string): Observable<IParameters> {
    return this.httpDirectBackend.get<IParameters>(this.urlProvider.getApiUrl('getPrametros') + '?Name=' + name);
  }

  verificarEmailUsuarioMarca(email: string, emailConfirm: string): Observable<ResultObject<boolean>> {
    if (!email || !emailConfirm) {
      console.error("🚨 Los correos electrónicos no pueden ser nulos.");
      return throwError(() => new Error("Emails no pueden ser nulos."));
    }
    return this.httpDirectBackend.post(`${this.urlProvider.getApiUrlExterno('usuarioMarca')}?userEmail=${email}&confirmEmail=${emailConfirm}`, null)
      .pipe(map(data => data as ResultObject<boolean>))
  }


  errorHandler(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
